import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAngleLightRight = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M20.802 20.982 7.192 34.385a1.388 1.388 0 0 1-1.964 0l-.82-.82a1.388 1.388 0 0 1 0-1.965L16.226 20 4.419 8.4a1.388 1.388 0 0 1 0-1.964l.82-.82a1.388 1.388 0 0 1 1.964 0l13.61 13.402a1.398 1.398 0 0 1-.01 1.964Zm14.79-1.964L21.98 5.615a1.388 1.388 0 0 0-1.964 0l-.82.82a1.388 1.388 0 0 0 0 1.965L31.015 20 19.208 31.6a1.388 1.388 0 0 0 0 1.964l.82.82a1.388 1.388 0 0 0 1.964 0l13.61-13.402a1.398 1.398 0 0 0-.01-1.964Z" })
});
export default SvgAngleLightRight;
